module.exports = __webpack_public_path__ + "img/symbol_10.911ae2e2.png";